<section style="height: 100%">
  <div class="login-box">
    <div class="login-logo">
      <img src="assets/images/CAPA3e.png" alt="capa logo">
    </div>
    <!-- /.login-logo -->
    <div class="login-box-body">
      <h3 class="login-box-msg" i18n="@@loginTitle">Login</h3>

      <form [formGroup]="loginForm" (ngSubmit)="onSubmit()">
        <div class="form-group has-feedback">
          <input type="email" formControlName="email" class="form-control" i18n-placeholder placeholder="Email">
          <span class="glyphicon glyphicon-envelope form-control-feedback"></span>
        </div>
        <div class="form-group has-feedback">
          <input type="password" formControlName="password" class="form-control" i18n-placeholder placeholder="Password">
          <span class="glyphicon glyphicon-lock form-control-feedback"></span>
        </div>
        <div class="row">
          <div class="col-xs-12">
            <button type="submit" class="btn btn-capa btn-block" style="margin-bottom: 1px; border-radius: unset" [disabled]="!loginForm.valid" i18n="@@loginButton">LOG IN</button>
          </div>
        </div>
        <div class="row">
          <div class="col-xs-12">
            <button (click)="goToAccountCreation()" style="border-radius: unset; background-color: #4cc1d2;" class="btn btn-capa btn-block" i18n="@@createAccount">CREATE AN ACCOUNT</button>
          </div>
        </div>
      </form>
    </div>
  </div>

  <div *ngIf="error" class="alert alert-danger" style="border-radius: unset; position: fixed; top:50px; width: 100%;">
    <span i18n="@@loginError">Error: Incorrect login or password</span>
  </div>
</section>
